import { useMutation } from '@tanstack/react-query';
import http from 'utils/http';

export function useUpdateReport() {
  return useMutation<any, any, any>({
    mutationFn: ({ id, ...values }) =>
      http.put<never, any>(`/api/reports/${id}/update`, {
        ...values,
      }),
  });
}

export default function useSaveReport() {
  return useMutation<any, any, any>({
    mutationFn: ({ id, ...values }) =>
      http.post<never, any>(`/api/reports/${id}/save`, values),
  });
}
